<template>
    <u-swiper-pagination-line v-bind="$attrs">
        <slot />
    </u-swiper-pagination-line>
</template>

<script>
import USwiperPaginationLine from "@/components/publish/styles/swipers/u-swiper-pagination-line.vue";

export default {
    props: {},
    components: {
        USwiperPaginationLine,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
